<template>
  <div class="login_page fillcontain">
    <transition name="form-fade" mode="in-out">
      <section class="form_contianer">
        <div class="left_logo">
          <div class="left_logo_small"></div>
          <div class="left_logo_text1">城市共享两轮车</div>
          <div class="left_logo_text2">监管平台</div>
        </div>
        <div class="right_text">欢迎</div>
        <el-form
          class="right_table"
          :model="loginForm"
          :rules="rules"
          ref="loginForm"
        >
          <el-form-item prop="username">
            <span class="logintext">用户名</span>
            <br />
            <el-input
            class="paperview-input-text"
              style="width: 370px"
              v-model="loginForm.username"
              placeholder="请输入用户名"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <span class="logintext">密码</span>
            <br />
            <el-input
            class="paperview-input-text"
              type="password"
              style="width: 370px"
              placeholder="请输入密码"
              v-model="loginForm.password"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              style="width: 370px"
              @click="submitForm('loginForm')"
              class="submit_btn"
              >登录</el-button
            >
          </el-form-item>
        </el-form>
        <!-- <div class="log-face"  v-if="switchhost == 'true'">
          <img src="../assets/logo.png"
               alt="">
        </div>
        <div class="log-face" v-if="switchhost == 'false'">
          <img src="../assets/朵朵logo-02.png"
               alt="">
        </div> -->
        <!-- <div class="manage_tip"
             v-if="switchhost == 'true'">城市共享两轮车监管平台</div>
        <div class="manage_tip"
             v-if="switchhost == 'false'">朵朵系统后台</div> -->
        <!-- <el-form :model="loginForm"
                 :rules="rules"
                 ref="loginForm">
          <el-form-item prop="username">
            <el-input v-model="loginForm.username"
                      placeholder="用户名"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password"
                      placeholder="密码"
                      v-model="loginForm.password"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="submitForm('loginForm')"
                       class="submit_btn">登录</el-button>
          </el-form-item>
        </el-form> -->
      </section>
    </transition>
  </div>
</template>


<script>
// import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      switchhost: "",
      loginForm: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.switchhost = sessionStorage.getItem("switchhost");
    // if(sessionStorage.getItem('token')){
    //     this.$router.push({
    //         path: "/main"
    //     })
    // }
  },
  // computed: {},
  methods: {
    submitForm(formName) {
      // alert(1);
      // alert(this.loginForm.username)
      //   alert(this.loginForm.password)
      this.$opsaxios
        .post("/api/v1/member/user/login", {
          username: this.loginForm.username,
          password: this.loginForm.password,
        })
        .then((res) => {
          console.info(res);
          if (res.data.code == "0") {
            this.$message({
              type: "success",
              message: "登陆成功",
            });
            sessionStorage.setItem("token", res.data.data.memberinfo.token);
            let _info = JSON.stringify(res.data.data.memberinfo);
            sessionStorage.setItem("userinfo", _info);
            let _datas = JSON.stringify(res.data.data.memu);
            sessionStorage.setItem("mnues", _datas);
            console.log("_datas",_datas)
            setTimeout(() => {
              // bus.$emit("mnues", res.data.menu);
              this.$router.push({
                path: "/main",
              });
              window.location.reload();
            }, 400);
          } else {
            this.$message({
              type: "warning",
              message: res.data.message,
            });
          }
        });
    },
  },
};
</script>


<style scoped>
.login_page {
  width: 100%;
  height: 100vh;
  text-align: center;
  background: url("../assets/logo_background.png") center center no-repeat;
}
.form_contianer {
  width: 998px;
  height: 622px;
  background: #fff;
  box-shadow: 0px 18px 36px 1px rgba(55, 125, 255, 0.19);
  text-align: center;
  position: absolute;
  left: calc(50% - 500px);
  top: calc(50% - 310px);
}
.log-face img {
  width: 100px;
  height: auto;
  margin: 0 auto;
}
.manage_tip {
  color: #fff;
  font-size: 28px;
  margin: 25px 0;
}
.manage_tip p {
  font-size: 34px;
  padding: 20px 0;
}
.submit_btn {
  color: #fff;
  width: 100%;
  font-size: 16px;
  
background: linear-gradient(136deg, #85E3FF 0%, #569DFC 60%, #3277FF 100%);
border-radius: 27px;
}
.form-fade-enter-active,
.form-fade-leave-active {
  transition: all 1s;
}
.form-fade-enter,
.form-fade-leave-active {
  transform: translate3d(0, -50px, 0);
  opacity: 0;
}
.left_logo {
  width: 441px;
  height: 622px;
  position: relative;
  background: url("../assets/logo_bg2.png") center center no-repeat;
}
.left_logo_small {
  width: 182px;
  height: 182px;
  left: 130px;
  top: 117px;
  position: absolute;
  background: url("../assets/平台logo.png") center center no-repeat;
}
.left_logo_text1,
.left_logo_text2 {
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 50px;
}
.left_logo_text1 {
  padding-top: 327px;
}

.right_text {
  font-size: 36px;
  font-weight: 500;
  color: #333333;
  top: 92px;
  left: 684px;
  position: absolute;
}
.right_table {
  position: absolute;
  top: 214px;
  left: 530px;
}

.logintext {
  float: left;
  font-size: 16px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #666666;
  line-height: 22px;
}

.paperview-input-text >>> .el-input__inner {
  -webkit-appearance: none;
  background-color: #FFF;
  background-image: none;
  border-radius: 0px;
  border: 0px;
  border-bottom: 1px solid #D0D0D0;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/login.vue